import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Game} from "../Game";
import {GameFeatureMode} from "../enums/Enum";

export class ZeroBetIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        Game.foregroundElements.waysCounter.updatePossibleWaysCounter(true);
        Game.model.setPreviousSpinFSLeftCount();
        Game.keypadPlugin.setWin(Game.model.data.accumulatedRoundWin, true, Game.isWinBelowStake());
        if (Game.model.isStickyDeadApplicable() && !Game.model.isRestore) {
            Game.stickyView.reArrangeStickDeadMultiplier();
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
        //freespinsLeft is missing from the init data in mental2, that's why this is here.
        if (Game.model.isRestore) {
            Game.reelView.show();
        }
        SlotGame.keypadPlugin.setZeroBetSpinCounter(Game.model.data.freespinsLeft - 1)
        flowStateController.finish();
    }
}